// Sanity Headless CMS connection to db
import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "zzqf73y8",
  dataset: "production",
  useCdn: true,
  apiVersion: "2021-03-25"
});